import { render, staticRenderFns } from "./BlacklistQueryList.vue?vue&type=template&id=0cad9778&scoped=true&"
import script from "./BlacklistQueryList.vue?vue&type=script&lang=js&"
export * from "./BlacklistQueryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad9778",
  null
  
)

export default component.exports